
import { Component, ModelSync, Prop, Vue } from 'nuxt-property-decorator'
import type { ProviderModel } from '@alao-frontend/erp-services'
import UiDropdown from '~/components/ui/UIDropdown/UiDropdown.vue'
import UiDropdownItem from '~/components/ui/UIDropdown/UiDropdownItem.vue'
import UiDropdownHandle from '~/components/ui/UIDropdown/UiDropdownHandle.vue'

@Component({
  components: {
    UiDropdownHandle,
    UiDropdownItem,
    UiDropdown,
  },
})
export default class ProviderFilter extends Vue {
  @ModelSync('value', 'change', {
    required: true,
    type: Number,
    default: 0,
  })
  selectedOptionId!: number

  @Prop({ required: true, default: () => ([]), type: Array })
  readonly options!: ProviderModel[]

  get selectedOption () {
    return this.options.find(option => this.selectedOptionId === option.id)!
  }

  onOptionClick (id: number) {
    this.selectedOptionId = id
  }
}
